import { Absence } from "@/models/absences";
import { AbsenceType } from "@/models/absenceTypes-model";
import { eSalerySystem } from "@/models/institution-model";
import store from "@/store";

export default class LoenserviceHandler {
  static INITIAL: string = "Initial";
  static CREATED: string = "Created";
  static DELIVERED: string = "Delivered";
  static FAILED_IN_APPLICATION: string = "FailedInApplication"; // 3
  static FAILED_IN_LOENSYSTEM: string = "FailedInLoensystem"; // 4
  static SIMULATION_SUCCEEDED: string = "SimulationSuceeded";
  static SIMULATION_FAILED: string = "SimulationFailed";
  static UPDATED: string = "Updated";
  static PENDING: string = "Pending";
  static READY_FOR_DELIVERY: string = "ReadyForDelivery";
  static TO_BE_CLOSED: string = "ToBeClosed";
  static MISSING_INFO: string = "MissingInfo";
  static OBSOLETE: string = "Obsolete";

  static getStatus(
    absence: Absence | undefined,
    loenserviceStatus: string,
    errorMessage: string = ""
  ): eSalaryAbsenceStatus {
    if (
      loenserviceStatus === LoenserviceHandler.FAILED_IN_APPLICATION ||
      loenserviceStatus === LoenserviceHandler.FAILED_IN_LOENSYSTEM ||
      loenserviceStatus === LoenserviceHandler.SIMULATION_FAILED
    ) {
      return eSalaryAbsenceStatus.FAILED;
    }

    if (
      loenserviceStatus === LoenserviceHandler.PENDING ||
      loenserviceStatus === LoenserviceHandler.READY_FOR_DELIVERY
    ) {
      return eSalaryAbsenceStatus.PENDING;
    }

    if (absence) {
      const absenceType: AbsenceType = store.getters["absences/GetAbsenceTypeById"](
        absence.absence_type_id
      );
      if (absenceType.salary_system === eSalerySystem.SD) {
        if (!absence.abs_filing_date && absence.is_open) {
          return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
        }
        if (absence.abs_filing_date && absence.is_open) {
          return eSalaryAbsenceStatus.TO_BE_CLOSED;
        }
        if (!absenceType.is_system_defined) {
          return eSalaryAbsenceStatus.CANNOT_BE_REPORTED;
        }
        if (!absence.fit_filing_date && !absence.abs_filing_date) {
          return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
        }
        if (absence.fit_filing_date && absence.corrected) {
          return eSalaryAbsenceStatus.DELIVERED;
        }
        if (errorMessage !== "") {
          return eSalaryAbsenceStatus.MISSING_INFO;
        }
      }
      if (absenceType.salary_system === eSalerySystem.KMD) {
        if (loenserviceStatus === LoenserviceHandler.DELIVERED && absence.is_open) {
          return eSalaryAbsenceStatus.TO_BE_CLOSED;
        }
        if (!absenceType.is_system_defined || !absenceType.report_to_salary_system) {
          return eSalaryAbsenceStatus.CANNOT_BE_REPORTED;
        }
        if (absence.status === LoenserviceHandler.UPDATED) {
          return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
        }
        if (absence.fit_filing_date && absence.corrected) {
          return eSalaryAbsenceStatus.DELIVERED;
        }
        if (absence.status === LoenserviceHandler.INITIAL && errorMessage !== "") {
          return eSalaryAbsenceStatus.MISSING_INFO;
        }
        if (absenceType.dialog_properties?.additional_data && absence.kmd_additional_data === "") {
          return eSalaryAbsenceStatus.MISSING_INFO;
        }
        if (absence.status === LoenserviceHandler.INITIAL && errorMessage === "") {
          return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
        }
        /*       if (absence.status === LoenserviceHandler.UPDATED) {
        return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
      } */

        if (
          loenserviceStatus === LoenserviceHandler.DELIVERED &&
          !absence.fit_filing_date &&
          absenceType.dialog_properties?.kmd_open_allowed
        ) {
          return eSalaryAbsenceStatus.READY_FOR_DELIVERY;
        }
        if (
          loenserviceStatus === LoenserviceHandler.DELIVERED &&
          absence.fit_filing_date &&
          absenceType.dialog_properties?.obsolete
        ) {
          return eSalaryAbsenceStatus.DELIVERED;
        }
        if (absenceType.dialog_properties?.obsolete) {
          return eSalaryAbsenceStatus.OBSOLETE;
        }
      }
    }

    if (
      loenserviceStatus === LoenserviceHandler.INITIAL ||
      loenserviceStatus === LoenserviceHandler.CREATED ||
      loenserviceStatus === LoenserviceHandler.SIMULATION_SUCCEEDED
    ) {
      return eSalaryAbsenceStatus.INITIAL;
    } else if (loenserviceStatus === LoenserviceHandler.DELIVERED) {
      return eSalaryAbsenceStatus.DELIVERED;
    } else {
      return eSalaryAbsenceStatus.INITIAL;
    }
  }
}

export enum eSalaryAbsenceStatus {
  INITIAL = 0,
  DELIVERED = 2,
  FAILED = 3,
  PENDING = 4,
  MISSING_INFO = 5,
  TO_BE_CLOSED = 6,
  READY_FOR_DELIVERY = 7,
  OBSOLETE = 8,
  CANNOT_BE_REPORTED = 9
}
